import * as React               from 'react';
import { StatelessComponent }   from 'react';

interface MenuItemProps {
    onClickAction: () => void,
    label: string,
    target?: string,
}

const MenuItem: StatelessComponent<MenuItemProps> = ({onClickAction, label, target}) => {
    return (
        <li>
            <a onClick={onClickAction} target={target}>{label}</a>
        </li>
    );
};
export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/MenuItem.tsx